import { PrivateRoute } from "./PrivateRoute";

/**
 * Role-based route guards using the existing PrivateRoute component
 * These provide a cleaner and more maintainable approach to role-based routing
 */

export const AdminRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["admin"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const ManagerRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["manager"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const AdminOrManagerRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["admin", "manager"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const AdminManagerOrClientSupportRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["admin", "manager", "clientSupport"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const DeliveryPersonRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["livreur"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const AdminOrDeliveryPersonRoute = ({ children, ...props }) => (
  <PrivateRoute
    requiredRoles={["admin", "livreur"]}
    showError={true}
    {...props}
  >
    {children}
  </PrivateRoute>
);

export const AdminManagerOrDeliveryPersonRoute = ({ children, ...props }) => (
  <PrivateRoute
    requiredRoles={["admin", "manager", "livreur"]}
    showError={true}
    {...props}
  >
    {children}
  </PrivateRoute>
);

export const ClientRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["client"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

export const ClientSupportRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={["clientSupport"]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);

// For routes that require any authenticated user (no specific role)
export const AuthenticatedRoute = ({ children, ...props }) => (
  <PrivateRoute requiredRoles={[]} showError={true} {...props}>
    {children}
  </PrivateRoute>
);
